/* 
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React, {MouseEvent} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {dlsColor} from '../../theme/theme';
import {DLSTheme} from '../../types/types';

export interface RoundedChipButtonType {
  color?: string;
  labelText: string;
  textColor?: string;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
}

const useStyles = makeStyles((theme: DLSTheme) => ({
  chipButton : {
    backgroundColor : ({color}: {color: string}) => color,
    width           : 'fit-content',
    padding         : '4px 8px',
    borderRadius    : '10px',
    color           : ({textColor}: {textColor: string}) => textColor || dlsColor('grey3'),
    border          : 'none',
    outline         : 'none',
    ...theme.dls?.typography?.chipButton,
    '&:hover'       : {
      cursor : 'pointer'
    }
  }
}));

/**
 * 
 * @function RoundedChipButton
 * 
 * Button that like a chip completely rounded 
 * on the edges. Similar to a label but as a button 
 * and fully rounded corners
 */
export const RoundedChipButton = ({
  color = dlsColor('grey5'),
  labelText,
  onClick,
  textColor
}: RoundedChipButtonType) => {
  const classes = useStyles({color, textColor});
  return (
    <button className={classes.chipButton} onClick={onClick}>
      {labelText}
    </button>
  );
};

export default RoundedChipButton;
